import type { ICourseReviewStatesResponse } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createGetApi } from "@api/util/createGetApi";

const getApis = createGetApi<
  IApiResponse<ICourseReviewStatesResponse>,
  IPathBaseParam,
  object
>("courses.reviews.states");

export const states = {
  ...getApis,
};
